import i18n from 'i18next';

export function isTranslatedDomain() {
    const hostname = window.location.hostname.toLowerCase();

    return (
        hostname.includes('k-countries') ||
        hostname.includes('kcountries') ||
        hostname.includes('k-dealer') || 
        hostname.includes('kdealer') || hostname.includes('local')
    );
}

export function changeAppLanguage(lang) {
    if (!isTranslatedDomain()) {
        return;
    }

    i18n.changeLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
}
